<template>
    <div class="page-table haberTanim  mainDiv" id="affix-container">

        <div class="card-base baslikBg">{{hasta}} - Randevu Bilgileri</div>
        <el-row>
            <el-form label-position="top" status-icon :model="hastaForm" :rules="rulesHasta" ref="hastaForm"
                     class="demo-ruleForm">
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <div>
                        <el-row>
                            <div class="animated fadeInUp"
                                 style="display: flex; justify-content: center; margin-top: 50px; margin-bottom: 30px">
                                <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                    <div class="tarih-border" style="width: 100%">
                                        <div class="tarih-border-icon">
                                            <i class="el-icon-date"></i>
                                        </div>
                                        <div style="overflow:hidden;">
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p" style="margin-top: 5px !important;">
                                                <div style="width: 100%;display: flex;justify-content: center">
                                                    <el-form-item label='Hekim: '
                                                                  prop="randevuHekim">
                                                        <el-select
                                                                filterable
                                                                v-model="hastaForm.randevuHekim"
                                                                placeholder='Hekim Seçiniz'
                                                                style="width: 100%">
                                                            <el-option v-for="item in hastaForm.doktor"
                                                                       :key="item.hekimId"
                                                                       :label="item.adSoyad"
                                                                       :value="item.hekimId"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </div>
                                            </el-col>

                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p" style="margin-top: 5px !important;">
                                                <div style="width: 100%;display: flex;justify-content: center">
                                                    <el-form-item prop="randevuTarihi">
                                                        <el-date-picker
                                                                v-on:change="tarihChange(hastaForm.randevuTarihi,'randevu')"
                                                                v-model="hastaForm.randevuTarihi"
                                                                type="datetime"
                                                                :picker-options="dateRangeOptions"
                                                                format="yyyy-MM-dd HH:mm:ss"
                                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                                placeholder="Randevu Tarihi"
                                                                default-time="12:00:00">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </div>
                                    </div>
                                </el-col>
                            </div>
                        </el-row>
                        <div>
                            <el-col :xl="6" :lg="8" :md="10" :sm="24" :xs="24" class="col-p" aria-disabled="true">
                                <div class="card-base card-shadow--medium margin-top-20 demo-box bg-white animated fadeInLeft"
                                     style="position: relative">
                                    <el-form-item
                                            style="position: relative"
                                            prop="disId'">
                                        <dis-s-v-g-ran :ceruygulama="hastaForm.cerrahiUygList" :randevu="hastaForm.randevuList" v-on:disMet="getRandevuDetay"></dis-s-v-g-ran>
                                        <div v-if="disIdRan !==''" class="animated fadeIn gharipDis"></div>
                                        <span v-if="disIdRan !==''" class="animated fadeIn gharipDisYazi">{{disIdRan}}</span>
                                        <el-button v-if="disIdRan !==''" size="mini" class="disIptalButon" @click="disIptalRan(disIdRan)">
                                            İptal
                                        </el-button>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :xl="18" :lg="16" :md="14" :sm="24"
                                    :xs="24" class="col-p">
                                <div class="card-base card-shadow--medium margin-top-20 demo-box bg-white animated fadeInLeft dis-sol">
                                    <el-col :span="24" class="col-p" style="padding: 70px 0;">
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Planlanan Uygulama: '
                                                          prop="ekTedaviIdRan">
                                                <el-select
                                                        v-on:change="getEkUrunlerList(disIdRan)"
                                                        :disabled="rightDisableRan"
                                                        filterable
                                                        v-model="ekTedaviIdRan"
                                                        placeholder='Ek Tedavi Seçiniz'
                                                        style="width: 100%">
                                                    <el-option v-for="item in ekTedaviList"
                                                               :key="item.ektedaviId"
                                                               :label="item.baslik"
                                                               :value="item.ektedaviId"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Protetik Ürün: ' prop="ekUrunIdRan">
                                                <el-select
                                                        v-on:change="disOnayKaydetRan(disIdRan)"
                                                        :disabled="rightDisableRan"
                                                        filterable
                                                        v-model="ekUrunIdRan"
                                                        placeholder='Ek Ürün Seçiniz'
                                                        style="width: 100%">
                                                    <el-option v-for="item in ekUrunList"
                                                               :key="item.ekurunId"
                                                               :label="item.baslik"
                                                               :value="item.ekurunId"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Lot: ' prop="ekUrunLotRan">
                                                <el-input
                                                        v-on:change="disOnayKaydetRan(disIdRan)"
                                                        :disabled="rightDisableRan"
                                                        @input="ekUrunLotRan=ekUrunLotRan.toUpperCase()"
                                                        v-model="ekUrunLotRan"
                                                        placeholder='Lot Giriniz'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='ISQ: ' prop="isqRan">
                                                <el-input
                                                        v-on:change="disOnayKaydetRan(disIdRan)"
                                                        :disabled="rightDisableRan"
                                                        v-mask="'####################'"
                                                        v-model="isqRan"
                                                        placeholder='ISQ Giriniz'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Açıklama: ' prop="aciklamaRan">
                                                <el-input
                                                        v-on:change="disOnayKaydetRan(disIdRan)"
                                                        :disabled="rightDisableRan"
                                                        v-model="aciklamaRan"
                                                        placeholder='Açıklama'></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-col>
                                </div>
                            </el-col>
                        </div>
                    </div>
                </el-col>

            </el-form>
        </el-row>
        <el-col :span="24">

            <el-button class="margin-bottom-50 estas-buton ileriButton" size="small"
                       type="primary"
                       style="float: right;margin-top: 15px;"
                       @click="randevuGuncelleme">
                Kaydet
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                    <path fill="#fff" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
                </svg>
            </el-button>
            <el-button class="margin-bottom-50 ButonGolgesi" size="small"
                       type="danger"
                       icon="el-icon-delete"
                       style="float: right;margin-top: 15px;margin-right: 5px"
                       @click="randevuIptal">
                Randevu İptal
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import DisSVGRan from '@/components/DisSVGRan'
    import EventBus from '@/components/event-bus'
    import cerrahiService from '../../../WSProvider/CerrahiService'
    import randevuService from '../../../WSProvider/RandevuService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import JQuery from 'jquery';

    var hastaFormKlon = {};

    let $ = JQuery;
    export default {
        name: "HastaTanimlama",
        components: {
            DisSVGRan
        },

        data() {
            return {
                disIdRan: '',
                ekUrunIdRan: '',
                ekUrunLotRan: '',
                ekTedaviIdRan: '',
                isqRan: '',
                aciklamaRan: '',
                rightDisableRan: true,


                hasta: '',
                hastaId: '',
                hekimId: '',
                updateData: [],
                urunList: [],
                ekUrunList: [],
                ekTedaviList: [],
                ekTedaviListKlon: [],

                dateRangeOptions: {
                    firstDayOfWeek: 1,
                },
                hastaForm: {
                    doktor : [],
                    randevuTarihi: '',
                    randevuHekim: '',
                    randevuList: [],
                },
                rulesHasta: {},
            }
        },
        mounted() {
            let self = this;
            this.getUrunList();
            this.getEkTedaviList();

            EventBus.$on('denemeRan', function (disId) {
                if (disId) {
                    self.rightDisableRan = false;
                    if (self.disIdRan !== '') {
                        self.disOnayKaydetRan(self.disIdRan)
                    }
                    self.disIdRan = disId;
                    var obj = self.hastaForm.randevuList.find(data => parseInt(data.disId) === disId)
                    if (obj) {
                        self.ekUrunIdRan = obj.ekUrunId;
                        self.ekUrunLotRan = obj.lotNo;
                        self.isqRan = obj.isq;
                        self.aciklamaRan = obj.aciklama;
                        self.ekTedaviIdRan = obj.ekTedaviId;
                    }else{
                        self.ekUrunIdRan = '';
                        self.ekUrunLotRan = '';
                        self.isqRan = '';
                        self.aciklamaRan = '';
                        self.ekTedaviIdRan = '';
                    }
                }
            });

        },
        created(){
            this.hastaId = this.$store.state.hastaId;
            this.hekimId = this.$store.state.hekimId;
            this.updateId = this.$store.state.updateKodu;
        },
        methods: {

            disOnayKaydetRan(disId) {
                let self = this;
                var obj = self.hastaForm.randevuList.find(data => parseInt(data.disId) === disId)
                if (obj === undefined) {
                    self.hastaForm.randevuList.push({
                        disId: disId,
                        ekUrunId: self.ekUrunIdRan,
                        lotNo: self.ekUrunLotRan,
                        isq: self.isqRan,
                        aciklama: self.aciklamaRan,
                        ekTedaviId: self.ekTedaviIdRan,
                    });
                } else {
                    obj.ekUrunId = self.ekUrunIdRan;
                    obj.lotNo = self.ekUrunLotRan;
                    obj.isq = self.isqRan;
                    obj.aciklama = self.aciklamaRan;
                    obj.ekTedaviId = self.ekTedaviIdRan;
                }


            },
            disIptalRan(disId) {
                this.disIdRan = '';
                var obj = this.hastaForm.randevuList.find(data => data.disId === disId);
                this.hastaForm.randevuList.splice(this.hastaForm.randevuList.indexOf(obj),1);
                EventBus.$emit("disListRan", true)
            },
            getEkUrunlerList(disIdRan) {
                cerrahiService.tedaviEkUrunListesi(1, "", "", this.ekTedaviIdRan).then((response) => {
                    if (response.status === 200) {
                        this.ekUrunList = response.data
                    } else notification.Status(response.status, this)
                })

            },
            getRandevuDetay() {
                let self = this;
                randevuService.randevuDetay(this.updateId).then((response) => {
                    if (response.status === 200) {
                        this.hastaForm.randevuTarihi = response.data.tarih
                        this.hasta = response.data.hasta
                        this.hastaForm.doktor = response.data.hekim
                        hastaFormKlon.randevuTarihi = response.data.tarih
                        hastaFormKlon.randevuList = response.data.uygulama;
                        response.data.uygulama.forEach(function (e) {
                            var item = {
                                disId: e.disId,
                                randevuId: e.randevuId,
                                ekUrunId: e.ekUrunId,
                                lotNo: e.lotNo,
                                isq: e.isq,
                                ekTedaviId: e.ekTedaviId,
                                aciklama: e.aciklama,
                            };
                            self.hastaForm.randevuList.push(item);
                        });
                        EventBus.$emit("disListRan", true)
                    }
                })
            },
            randevuIptal() {
                randevuService.randevuTarihDurumGuncelle(this.updateId).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Randevu iptal edildi.');
                        this.resetForm('hastaForm');
                    } else notification.Status(response.status, this);
                })
            },
            randevuGuncelleme() {
                let self = this;
                console.log(self.hastaForm)
                var klonDizi = [];
                for (var i = 0; i < self.hastaForm.randevuList.length; i++) {
                    let obj1 = hastaFormKlon.randevuList.find(data => data.randevuId === self.hastaForm.randevuList[i].randevuId);
                    console.log(self.hastaForm)
                    if (obj1 === undefined) {

                        self.updateData.push({
                            durum: 1,
                            disId: self.hastaForm.randevuList[i].disId,
                            ekUrunId: self.hastaForm.randevuList[i].ekUrunId,
                            lotNo: self.hastaForm.randevuList[i].lotNo,
                            isq: self.hastaForm.randevuList[i].isq,
                            ekTedaviId: self.hastaForm.randevuList[i].ekTedaviId,
                            aciklama: self.hastaForm.randevuList[i].aciklama,
                            hekimId: self.hastaForm.randevuHekim
                        });

                    }
                    if (self.hastaForm.randevuList.length !== 0) {
                        let obj2 = hastaFormKlon.randevuList.find(data => data.randevuId === self.hastaForm.randevuList[i].randevuId);
                        klonDizi.push(obj2);
                        if (obj2) {
                            for (var key in hastaFormKlon.randevuList[i]) {
                                if (self.hastaForm.randevuList[i][key] && self.hastaForm.randevuList[i][key] !== klonDizi[i][key]) {
                                    let obj3 = self.updateData.find(data => data.randevuId === self.hastaForm.randevuList[i].randevuId);
                                    if (obj3 === undefined) {
                                        self.updateData.push({
                                            durum: 2,
                                            disId: self.hastaForm.randevuList[i].disId,
                                            randevuId: self.hastaForm.randevuList[i].randevuId,
                                            ekUrunId: self.hastaForm.randevuList[i].ekUrunId,
                                            lotNo: self.hastaForm.randevuList[i].lotNo,
                                            isq: self.hastaForm.randevuList[i].isq,
                                            ekTedaviId: self.hastaForm.randevuList[i].ekTedaviId,
                                            aciklama: self.hastaForm.randevuList[i].aciklama,
                                            hekimId: self.hastaForm.randevuHekim
                                        })
                                    }

                                }
                            }
                        }

                    }
                }
                if (self.hastaForm.randevuTarihi !== hastaFormKlon.randevuTarihi) {
                    self.updateData.push({
                        durum: 'tarih',
                        tarih: self.hastaForm.randevuTarihi,
                        hekimId: self.hastaForm.randevuHekim
                    })
                }
                for (var j = 0; j < hastaFormKlon.randevuList.length; j++) {
                    let obj0 = self.hastaForm.randevuList.find(data => data.randevuId === hastaFormKlon.randevuList[j].randevuId);
                    if (obj0 === undefined) {
                        self.updateData.push({
                            durum: 0,
                            randevuId: hastaFormKlon.randevuList[j].randevuId,
                        })
                    }
                }
                randevuService.randevuGuncelleme(this.updateId, this.updateData).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Randevu güncellendi.');
                        this.resetForm('hastaForm');
                        // EventBus.$emit("cerrahiList", true)
                    } else notification.Status(response.status, this);
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "randevuguncelleme");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "randevuguncelleme") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            getUrunList() {
                cerrahiService.urunListesi(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.urunList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            // getEkUrunList() {
            //     cerrahiService.ekUrunListesi(1, '', '').then((response) => {
            //         if (response.status === 200) {
            //             this.ekUrunList = response.data;
            //         } else notification.Status(response.status, this)
            //     })
            //
            // },
            getEkTedaviList() {
                cerrahiService.ekTedaviListesi(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.ekTedaviList = response.data;
                        this.ekTedaviListKlon = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            open(val) {
                this.$notify.success({
                    title: 'Başarılı',
                    message: val + ' başarıyla eklendi.',
                    offset: 100
                });
            },
            inputStyleAlt(val) {
                var splitStr = val.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                this.hastaForm.adSoyad = splitStr.join(' ');
            },


            disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7
            }
        }
    }
</script>

<style scoped>
    .deleteButton {
        position: absolute;
        right: 5px;
        top: 0;
        z-index: 10;
        padding: 5px;
        border-radius: 0 0 0 5px;
    }

    .addButton {
        position: absolute;
        right: 5px;
        bottom: 0;
        z-index: 10;
        padding: 5px;
        border-radius: 5px 0 0 0;
    }


    .ileriButton {
        margin-right: 3px;
        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065)
    }


</style>
